import { columnHelper } from './helper';

export const message = columnHelper.accessor('Message', {
  header: 'Message',
  id: 'message',
});
